import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export const commentsLengthError = (comments, maximumLength) =>
    Number.isFinite(maximumLength) && comments?.length > maximumLength
        ? `Additional Comments cannot exceed ${maximumLength} characters.`
        : null;

export const AdditionalCommentsField = ({
    id,
    value,
    onChange,
    maximumLength,
    submitted = false,
}) => {
    const error = commentsLengthError(value, maximumLength);

    return (
        <FormGroup>
            <Label for={id}>Additional Comments</Label>
            <Input
                id={id}
                type="textarea"
                rows="3"
                placeholder="Place Comments Here"
                value={value}
                onChange={e => onChange(e.target.value)}
                invalid={submitted && Boolean(error)}
            />
            {Number.isFinite(maximumLength) && (
                <div className="small text-muted text-right">
                    {value?.length ?? 0} / {maximumLength}
                </div>
            )}
            {submitted && error && <p className="text-danger mt-1">{error}</p>}
        </FormGroup>
    );
};
